import antdBR from 'antd/lib/locale-provider/pt_BR';
import ptMessages from '../locales/pt_BR.json';

const BrLang = {
  messages: {
    ...ptMessages,
  },
  antd: antdBR,
  locale: 'pt-BR',
};
export default BrLang;